// eslint-disable-next-line no-console
console.log('Gen Ai Studio Logs', {
  version: import.meta.env.VITE_APP_VERSION,
});
